export function activateLinkFromKeyboardEvent(event) {
  const link = event.target.closest?.('a[href]');
  if (!link) return false;

  const isSpace = event.key === ' ' || event.key === 'Spacebar';
  const isEnter = event.key === 'Enter';
  if (!isSpace && !isEnter) return false;

  event.preventDefault();
  link.click();
  return true;
}

export function bindLinkKeyboardActivation(root) {
  if (!root) return () => {};

  const onKeydown = (event) => {
    activateLinkFromKeyboardEvent(event);
  };

  root.addEventListener('keydown', onKeydown);
  return () => root.removeEventListener('keydown', onKeydown);
}
